class CartNotificationBase extends HTMLElement {
  constructor() {
    super();

    this.notification = this.querySelector("#cart-notification-base");
    this.backgroundOverlay = document.querySelector("#background-overlay-base");
    this.header = document.querySelector("sticky-header");
    this.cartIcon = document.querySelector("#cart-icon-bubble");
    this.deleteItemBtns = null;
    this.deleteSingleItemBtn = null;
    this.btnKeepBuying = null;
    this.overlayCart = null;
    this.btnCloseCart = null;
    this.isUpdating = false;

    this.notification.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.cartIcon.addEventListener("click", this.open.bind(this));

    this.setHeaderCartIconAccessibility();
    this.updateQuantityEvent();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open();
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open();
      }
    });
  }

  open() {
    this.deleteItemBtns = this.querySelectorAll(".remove-item-js");
    this.btnKeepBuying = this.querySelector("#btn-keep-buying-base");
    this.overlayCart = this.querySelector("#background-overlay-base");
    this.btnCloseCart = this.querySelector("#close-btn-base");
    this.notification.classList.add("animate", "active");
    this.backgroundOverlay.classList.add("active");
    document.body.style.overflow = "hidden";
    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    this.deleteItemBtns.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        this.deleteSingleItemBtn = item;
        this.removeElementEvent(event);
      });
    });

    this.btnCloseCart &&
      this.btnCloseCart.addEventListener("click", () => {
        this.close();
        document.body.style.overflow = "auto";
      });

    this.btnKeepBuying &&
      this.btnKeepBuying.addEventListener("click", () => {
        this.close();
        document.body.style.overflow = "auto";
      });
    this.overlayCart &&
      this.overlayCart.addEventListener("click", () => {
        this.close();
        document.body.style.overflow = "auto";
      });
    
    setTimeout(() => {
      this.updateProductPrices();
    }, 300);
  }

  close() {
    console.log("Close Base");

    this.notification.classList.remove("active");
    this.backgroundOverlay.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (this.header) this.header.reveal();
    this.open();
    
    setTimeout(() => {
      this.updateProductPrices();
    }, 300);
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  removeElementEvent(event) {
    event.preventDefault();

    const url = this.deleteSingleItemBtn.getAttribute("href");
    const removeId = url.match(/id=([^&]*)/)[1];
    console.log("RemoveId: ", removeId);
    
    const productToRemove = this.deleteSingleItemBtn.closest('.cart-notification-product');

    fetch(url)
      .then((response) => {
        if (productToRemove) {
          productToRemove.remove();
        }
        return fetch('/cart.js');
      })
      .then((response) => response.json())
      .then((cart) => {
        console.log("Carrito actualizado:", cart);
        
        this.updateHeaderButton(cart);
        
        const remainingProducts = this.querySelectorAll('.cart-notification-product');
        remainingProducts.forEach((productElement, index) => {
          if (cart.items[index]) {
            const item = cart.items[index];
            
            const deleteBtn = productElement.querySelector('.remove-item-js');
            if (deleteBtn) {
              deleteBtn.setAttribute('href', `/cart/change?id=${item.key}&quantity=0`);
            }
            
            const priceElements = productElement.querySelectorAll('.product-option');
            
            if (priceElements.length > 0) {
              const priceElement = priceElements[priceElements.length - 1];
              
              if (item.original_line_price !== item.final_line_price) {
                priceElement.innerHTML = `
                  <span style="text-decoration: line-through; color: #999;">${Shopify.formatMoney(item.original_line_price, "{{amount_no_decimals}}€")}</span>
                  <span>${Shopify.formatMoney(item.final_line_price, "{{amount_no_decimals}}€")}</span>
                `;
              } else {
                priceElement.textContent = Shopify.formatMoney(item.final_line_price, "{{amount_no_decimals}}€");
              }
            }

            const quantitySelector = productElement.querySelector('.quantity-selector');
            if (quantitySelector) {
              quantitySelector.setAttribute('data-line', index + 1);
              quantitySelector.value = item.quantity;
            }
          }
        });
        
        setTimeout(() => {
          this.deleteItemBtns = this.querySelectorAll(".remove-item-js");
          this.deleteItemBtns.forEach((item) => {
            item.addEventListener("click", (e) => {
              e.preventDefault();
              this.deleteSingleItemBtn = item;
              this.removeElementEvent(e);
            });
          });
        }, 100);
      })
      .catch((error) => {
        console.error("Error al eliminar el artículo:", error);
      });
  }

  updateProductPrices() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        console.log("Actualizando precios de productos:", cart.items);
        
        const products = this.querySelectorAll('.cart-notification-product');
        products.forEach((productElement, index) => {
          if (cart.items[index]) {
            const item = cart.items[index];
            
            const priceElements = productElement.querySelectorAll('.product-option');
            
            console.log(`Producto ${index}: encontrados ${priceElements.length} elementos .product-option`);
            
            priceElements.forEach((priceElement) => {
              const text = priceElement.textContent.trim();
              if (text.includes('€') && /\d/.test(text)) {
                console.log(`Actualizando precio: ${text} -> ${item.final_line_price}`);
                
                if (item.original_line_price !== item.final_line_price) {
                  priceElement.innerHTML = `
                    <span style="text-decoration: line-through; color: #999;">${Shopify.formatMoney(item.original_line_price, "{{amount_no_decimals}}€")}</span>
                    <span>${Shopify.formatMoney(item.final_line_price, "{{amount_no_decimals}}€")}</span>
                  `;
                } else {
                  priceElement.textContent = Shopify.formatMoney(item.final_line_price, "{{amount_no_decimals}}€");
                }
              }
            });
          }
        });
      })
      .catch((error) => console.error("Error actualizando precios:", error));
  }

  updateQuantityEvent() {
    document.addEventListener("DOMContentLoaded", () => {
      document.addEventListener("change", (event) => {
        const dropdown = event.target.closest(".quantity-selector");
        if (dropdown) {
          const newQuantity = dropdown.value;
          const line = dropdown.getAttribute("data-line");
          this.updateCartQuantity(line, newQuantity);
        }
      });
    });
  }

  updateCartContent() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        this.updateHeaderButton(cart);
      });
  }

  updateHeaderButton(cart = {}) {
    const cartCountBubble = document.querySelector(".cart-count-bubble");
    const cartFooterPrice = document.querySelector(".totals__total-value");
    if (cartFooterPrice) {
      cartFooterPrice.textContent = Shopify.formatMoney(cart.total_price, "{{amount_no_decimals}}€");
    }
    if (cartCountBubble) {
      if (cart.item_count > 0) {
        document.querySelector("#CartDrawer-LiveRegionText")?.classList.add("visually-hidden");
        cartCountBubble.style.display = "block";
        const itemCountElement = cartCountBubble.querySelector('span[aria-hidden="true"]');
        if (itemCountElement) {
          itemCountElement.textContent = `(${cart.item_count})`;
        }

        const visuallyHiddenElement = cartCountBubble.querySelector(".visually-hidden");
        if (visuallyHiddenElement) {
          visuallyHiddenElement.textContent = `${cart.item_count} artículos en el carrito`;
        }
      } else {
        console.log("Ya no hay");
        document.querySelector("#CartDrawer-LiveRegionText")?.classList.remove("visually-hidden");
        cartCountBubble.style.display = "none";
      }
    }
  }

  removeItemFromModal(itemId) {
    console.log({ itemId });
    let itemElement = document.getElementById("cart-notification-product-" + itemId);
    if (!itemElement) return;
    itemElement.innerHTML = "";
    itemElement.remove();
  }

  updateCartQuantity(line, quantity) {
  if (this.isUpdating) {
    console.log("Ya hay una actualización en curso, esperando...");
    return;
  }
  
  this.isUpdating = true;
  
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity,
    }),
  })
    .then((response) => response.json())
    .then((cart) => {
      console.log("Cantidad actualizada:", cart);
      
      // Esperar más tiempo para que Shopify recalcule descuentos
      setTimeout(() => {
        // Obtener el carrito actualizado de nuevo
        fetch('/cart.js')
          .then((response) => response.json())
          .then((updatedCart) => {
            console.log("Carrito recalculado:", updatedCart);
            
            // Actualizar header y precio total
            this.updateHeaderButton(updatedCart);
            
            // Actualizar precios de productos
            const products = this.querySelectorAll('.cart-notification-product');
            products.forEach((productElement, index) => {
              if (updatedCart.items[index]) {
                const item = updatedCart.items[index];
                
                // Actualizar precio
                const priceElements = productElement.querySelectorAll('.product-option');
                if (priceElements.length > 0) {
                  const priceElement = priceElements[priceElements.length - 1];
                  
                  if (item.original_line_price !== item.final_line_price) {
                    priceElement.innerHTML = `
                      <span style="text-decoration: line-through; color: #999;">${Shopify.formatMoney(item.original_line_price, "{{amount_no_decimals}}€")}</span>
                      <span>${Shopify.formatMoney(item.final_line_price, "{{amount_no_decimals}}€")}</span>
                    `;
                  } else {
                    priceElement.textContent = Shopify.formatMoney(item.final_line_price, "{{amount_no_decimals}}€");
                  }
                }
                
                // Actualizar cantidad en el selector
                const quantitySelector = productElement.querySelector('.quantity-selector');
                if (quantitySelector) {
                  quantitySelector.setAttribute('data-line', index + 1);
                  quantitySelector.value = item.quantity;
                }
                
                // Actualizar botón de eliminar
                const deleteBtn = productElement.querySelector('.remove-item-js');
                if (deleteBtn) {
                  deleteBtn.setAttribute('href', `/cart/change?id=${item.key}&quantity=0`);
                }
              }
            });
            
            this.isUpdating = false;
          });
      }, 500);
    })
    .catch((error) => {
      console.error("Error al actualizar cantidad:", error);
      this.isUpdating = false;
    });
}
}

customElements.define("cart-notification-base", CartNotificationBase);


